import { render, staticRenderFns } from "./DocumentsBlock.vue?vue&type=template&id=55c71355&"
import script from "./DocumentsBlock.vue?vue&type=script&lang=js&"
export * from "./DocumentsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DocumentsBlock.vue"
export default component.exports